import React from 'react';
import styled from 'styled-components';
import { EmptyField } from '../../../healtheraComponents';
import { calculateSlaTimeslot } from '../../../helpers';
import { RAG_COLORS } from '../constants';

const SlaTimeslot = ({ rag, slaTimeslot, deliveryTimeslot, slaType, orderData }) => {
  return (
    <>
      {(slaTimeslot || deliveryTimeslot) && slaType ? (
        <>
          <SlaTypeBox>{slaType}</SlaTypeBox>
          <SlaTimeslotWrapper color={RAG_COLORS[rag]}>
            {calculateSlaTimeslot({ slaTimeslot, deliveryTimeslot, orderData })}
          </SlaTimeslotWrapper>
        </>
      ) : (
        <EmptyField />
      )}
    </>
  );
};

const SlaTypeBox = styled.div`
  font-size: 11px;
  padding-bottom: 6px;
  text-align: center;
`;

const SlaTimeslotWrapper = styled.div`
  font-weight: bold;
  border-radius: 10px;
  padding: 3px 8px;
  background: ${(props) => props.color};
  color: ${(props) => (props.color === RAG_COLORS.amber ? '#383847' : '#fff')};
  text-align: center;
`;

export default SlaTimeslot;
